import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";

import AdminProjectReview from "../components/AdminProjectReview";
import * as actions from "../../../../../actions/project.actions";
import * as adminActions from "../../../../../actions/admin.actions";
import * as commonActions from "../../../../../actions/common.actions";

const rejectedHeader = () => ({
  color: "strongGrey",
  title: "Project successfully rejected"
});

const subHeader = projectId => {
  return {
    items: [
      {
        caption: "Project Detail",
        url: `/admin/project/${projectId}/detail`
      },
      {
        caption: "Potential Matches",
        url: `/admin/project/${projectId}/potential-matches`
      }
    ],
    activeItem: 0
  };
};

const approvedSubHeader = (projectId, totalMatches, totalPitches) => {
  return {
    items: [
      {
        caption: "Project Detail",
        url: `/admin/project/${projectId}/detail`
      },
      {
        caption: `Matches (${totalMatches})`,
        url: `/admin/project/${projectId}/matches`
      },
      {
        caption: `Pitches (${totalPitches})`,
        url: `/admin/project/${projectId}/pitches`
      },
      {
        caption: "SOW",
        url: `/admin/project/${projectId}/sow`
      },
      {
        caption: "Reviews",
        url: `/admin/project/${projectId}/reviews`
      }
    ],
    activeItem: 4
  };
};

class AdminProjectReviewContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentProjectState: null
    };

    this.approveProject = this.approveProject.bind(this);
    this.rejectProject = this.rejectProject.bind(this);
  }

  componentDidMount() {
    this.props.adminActions.getProject(this.props.match.params.projectId);
    this.props.actions.getStatus();
  }

  componentDidUpdate(prevProps, prevState) {
    this.setHeaderBar(prevState);
  }

  setHeaderBar(prevState) {
    const project = this.props.project;
    const status = _.get(project, "status.name");

    const totalMatches = _.get(project, "stats.matches.matched");
    const totalPitches =
      _.get(project, "stats.pitches.accepted") +
      _.get(project, "stats.pitches.pending");

    let headerBar = {};
    let selectedSubHeader = {};
    let currentProjectState = status;

    if (status != undefined) {
      switch (status) {
        case "draft":
        case "submitted-for-approval":
          selectedSubHeader = subHeader(project.id, totalMatches);
          break;

        case "rejected":
          selectedSubHeader = subHeader(project.id, totalMatches);
          headerBar = rejectedHeader();
          break;

        default:
          selectedSubHeader = approvedSubHeader(
            project.id,
            totalMatches,
            totalPitches
          );
          break;
      }
    }

    if (currentProjectState !== prevState.currentProjectState) {
      this.props.commonActions.setHeaderBar(headerBar);
      this.props.commonActions.setSubHeader(selectedSubHeader);
      this.setState({ currentProjectState });
    }
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderBar({});
    this.props.commonActions.setSubHeader({});
  }

  approveProject() {
    const projectId = this.props.match.params.projectId;
    const payload = {
      project_id: projectId,
      status_id: 4
    };

    this.props.adminActions.updateProject(payload);
  }

  rejectProject(messageValue) {
    const projectId = this.props.match.params.projectId;
    const payload = {
      project_id: projectId,
      status_id: 3,
      comments: messageValue
    };

    this.props.adminActions.updateProject(payload);
  }

  render() {
    const project = this.props.project || {};

    return <AdminProjectReview projectData={project} />;
  }
}

const mapStateToProps = state => {
  return {
    project: state.admin.project
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminProjectReviewContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/project/reviews/containers/AdminProjectReviewContainer.js